import script from "./MembershipPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipPage.vue?vue&type=script&setup=true&lang=js"

import "./MembershipPage.css?vue&type=style&index=0&id=06b07284&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b07284"]])

export default __exports__